import { ServiceGroup, Service } from "../../model"

export function sortGroups(groups: ServiceGroup[], key: keyof ServiceGroup = "label"): void {
	groups.sort((a, b) => a[key] >= b[key] ? 1 : -1)
}

// Fonction qui verifie que le service appartient a un groupe de service, si vrai retourne l'id du groupe
export function isHisGroup(groups: (ServiceGroup | Service)[], service: Service): number|void {
	groups.forEach(grp => {
		if (service.serviceGroup === grp.id && isServiceGroup(grp)) return grp.id
		else return null
	})
}

export function isServiceGroup(data: (ServiceGroup | Service)): data is ServiceGroup {
	return (data as ServiceGroup).services !== undefined
}


export function isAllServicesChecked(group: ServiceGroup, services: Service[]) {
	if (!(group && group.services && group.services.length)) return false

	return group.services.every(service =>
		services.find(s => service === s.id) ? true : false)
}

export function findServiceById(services: Service[], id: number): Service | null {
	return services.find(service => service.id === id)
}

export function findGroupById(groups: ServiceGroup[], groupId: number): ServiceGroup {
	if (!groups.length) return null
	return groups.find(grp => grp.id === groupId)
}



// WEBPACK FOOTER //
// ./src/domain/sfp/service-group-domain.ts